function OpportuniesIcon() {
	return (
		<svg
			width="84"
			height="84"
			viewBox="0 0 84 84"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.5"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M74.2018 19.0187C79.3835 26.0484 79.7314 34.7209 80.4239 43.4094C81.1498 52.5184 84.2637 62.8288 78.2385 69.6697C72.182 76.5461 61.4924 74.3722 52.3553 75.278C42.3239 76.2725 32.1245 79.9524 23.2514 75.121C12.2719 69.1428 0.0191374 59.5322 0.553204 47.0723C1.08144 34.7486 16.7259 30.4081 25.5366 21.8074C33.3684 14.1622 37.6212 0.825423 48.5721 0.197905C59.5479 -0.431047 67.6648 10.1504 74.2018 19.0187Z"
				fill="#C8E4FF"
			/>
			<g clipPath="url(#clip0_326_73665)">
				<mask
					id="mask0_326_73665"
					style={{ maskType: "luminance" }}
					maskUnits="userSpaceOnUse"
					x="20"
					y="19"
					width="48"
					height="49"
				>
					<path d="M20 19.1655H68V67.1655H20V19.1655Z" fill="white" />
				</mask>
				<g mask="url(#mask0_326_73665)">
					<path
						d="M45.2908 53.4371L41.5177 56.6032C40.3278 57.6017 40.1725 59.3756 41.171 60.5655C42.1695 61.7555 43.9435 61.9107 45.1333 60.9122L48.9065 57.7462"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M48.9056 57.7462L47.287 59.1045C46.0971 60.1029 45.9418 61.8769 46.9403 63.0668C47.9388 64.2567 49.7127 64.4119 50.9026 63.4134L60.0394 55.7467H66.5938V40.7467H54.6169"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M41.675 49.128L37.9019 52.294C36.712 53.2925 34.9381 53.1374 33.9395 51.9474C32.9411 50.7575 33.0964 48.9835 34.2862 47.9851L42.9127 40.7465"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M41.6743 49.1285L37.9012 52.2946C36.7113 53.2931 36.5561 55.0671 37.5545 56.257C38.553 57.4469 40.327 57.6021 41.5168 56.6036L45.29 53.4376"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						opacity="0.5"
						d="M38.0027 56.6846H32.3752L28.6252 52.9346H21.4065V37.9346H32.7502L33.6406 37.0442C34.8713 35.8135 36.5405 35.1221 38.2809 35.1221H46.9735C48.2167 35.1221 49.409 35.616 50.2881 36.495L54.9582 41.0884C56.0566 42.1866 56.0566 43.9675 54.9582 45.0658C53.8598 46.1641 52.0791 46.1641 50.9808 45.0658L46.6621 40.7471H42.9121"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						opacity="0.5"
						d="M44.0002 22.2591V26.9036"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						opacity="0.5"
						d="M50.5627 29.2903L54.3127 25.5403"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						opacity="0.5"
						d="M37.4377 29.2903L33.6877 25.5403"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_326_73665">
					<rect
						width="48"
						height="48"
						fill="white"
						transform="translate(20 19.167)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default OpportuniesIcon;
